import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

import getCustomerAssets from '~/auth/assets'
import EmailSupport from '~/components/EmailSupport'
import Link from '~/components/Link'
import { Overlay, createOverlay } from '~/components/Overlay'

const HelpOverlay = createOverlay(() => {
  const t = useTranslations('layouts.HelpOverlay')
  const customerAssets = getCustomerAssets()

  return (
    <Overlay fullWidth maxWidth="sm">
      <Overlay.Header title={t('needHelpTitle')} />
      <Overlay.Content>
        <Typography variant="body1" sx={{ pt: 4, pb: 8 }}>
          {customerAssets?.supportEmail
            ? t.rich('emailUsAt', {
                email: () => <EmailSupport />
              })
            : t.rich('visitDocsOrEmail', {
                docLink: (chunks) => (
                  <Link href="https://synop.readme.io/" sx={{ fontWeight: 'bold' }} target="_blank">
                    {chunks}
                  </Link>
                ),
                email: () => <EmailSupport />
              })}
        </Typography>
      </Overlay.Content>
    </Overlay>
  )
})

export default HelpOverlay
